export enum ApplicationRole {
  SupplierManager = "SupplierManager",
  StoreManager = "StoreManager",
  OrderApprover = "OrderApprover",
  Owner = "Owner",
  Unknown = "Unknown",
}
